import { Modal } from '../components/Modal';

type Props = {
    onClose: () => void;
    /** Caller's fresh referral count (server-driven). Drives the CTA. */
    freshRefs?: number;
    /** Open the bonuses view (referrals tab) and close. */
    onGoToReferrals?: () => void;
};

/**
 * BIG GIVEAWAY rules popup. Triggered manually from the view AND auto-shown
 * when the user lands here via the channel deeplink (Интеграция с каналом.md):
 * if their fresh-referrals counter is zero, surface the "К рефералам" CTA
 * so the path from "saw the channel post" to "got an entry" is one tap.
 */
export function GiveawayRulesModal({ onClose, freshRefs, onGoToReferrals }: Props) {
    const hasFresh = (freshRefs ?? 0) > 0;
    return (
        <Modal title="Условия участия" onClose={onClose}>
            <p className="popup-text text-center">
                Нужно пригласить <b>минимум 1 реферала</b> до начала раздачи.
            </p>
            <p className="popup-text text-center">
                Для каждой новой раздачи приглашайте 1 нового реферала.
            </p>
            {freshRefs !== undefined && (
                <p className="popup-text text-center" style={{ color: hasFresh ? 'var(--green)' : 'var(--red)' }}>
                    Свежих рефералов: <b>{freshRefs}</b>
                </p>
            )}
            <p className="popup-text text-center text-accent">
                Уведомление о победителях придёт в 🔔
            </p>
            {!hasFresh && onGoToReferrals
                ? (
                    <button type="button" className="action-btn btn-gold" onClick={onGoToReferrals}>
                        К РЕФЕРАЛАМ
                    </button>
                )
                : (
                    <button type="button" className="action-btn btn-blue" onClick={onClose}>
                        Понятно
                    </button>
                )}
        </Modal>
    );
}
